import React, { useState } from "react";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
//import Style from "./CompteLeaderUsersList.scss";

const ProfilAddUser = ({ onClose, entityId }) => {
   const [email, setEmail] = useState(""); // State to manage email input
   const [forename, setForename] = useState("");
   const [name, setName] = useState("");

   const handleSubmit = async (event) => {
      event.preventDefault();
      try {
          const response = await fetch("/Api/admin/provision_user", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute('content') // Ensure CSRF token is included
              },
              body: JSON.stringify({
                  email,
                  forename: forename,        // Include first name in the request body
                  name: name,                // Include last name in the request body
                  user_team_id: entityId,    // Include entityId in the request body
                  role: 4 // Only able to create simple users
              })
          });
  
          if (response.ok) {
              const data = await response.json();
              // Handle success (e.g., show a success message, clear the form, etc.)
              onClose();
          } else {
              const data = await response.json();
              alert("Une erreur s'est produite. Veuillez vérifier le résultat de l'opération manuellement.");
              // Handle failure (e.g., show an error message)
          }
      } catch (error) {
          console.error("Error provisioning user:", error);
          alert("Une erreur s'est produite. Veuillez vérifier le résultat de l'opération manuellement.");
      }
  };
  

   return (
      <div id={"ue-modal1-wrapper"} className={"ue-modal1-wrapper"}>
         <div id={"ue-modal1"} className={"ue-modal1 d-flex flex-column h-100 w-100"}>
            <div className={"w-100"}>
               <div className={"d-flex flex-row justify-content-between align-items-center mb-4"}>
                  <div className={"h6 w-100 text-start"} style={{ fontWeight: "700" }}>
                     AJOUTER UN UTILISATEUR{" "}
                  </div>
                  <div className={"ue-btn-icon-sm close"} onClick={onClose}>
                     <Icon className={"mx-2"} path={mdiClose} size={0.8} color={"var(--theme_primary)"} />
                  </div>
               </div>

               <form
                  className={"d-flex flex-column justify-content-center align-items-center"}
                  onSubmit={handleSubmit}
               >
                  <div style={{ width: "100%" }}>
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="email"
                           id="email"
                           name="email"
                           placeholder=" "
                           value={email}
                           onChange={(e) => setEmail(e.target.value)} // Update state on input change
                           required
                        />
                        <label className="did-floating-label">
                           Veuillez entrer l'adresse e-mail de votre nouveau compte utilisateur.
                        </label>
                     </div>
                     <div className="form-row justify-content-between">    
                        <div className="did-floating-label-content w-50 p-1">
                           <input
                              className="did-floating-input"
                              type="text"
                              id="forename"
                              name="forename"
                              placeholder=" "
                              value={forename}
                              onChange={(e) => setForename(e.target.value)} // Update state on input change
                              required
                           />
                           <label className="did-floating-label">
                              Prénom.
                           </label>
                        </div>
                        <div className="did-floating-label-content w-50 p-1">
                           <input
                              className="did-floating-input"
                              type="text"
                              id="name"
                              name="name"
                              placeholder=" "
                              value={name}
                              onChange={(e) => setName(e.target.value)} // Update state on input change
                              required
                           />
                           <label className="did-floating-label">
                              Nom de famille.
                           </label>
                        </div>
                     </div>
                  </div>
                  <button className={"btn btn-primary text-white font-weight-bold w-100 mt-3"} type="submit">
                     ENVOYER
                  </button>
               </form>
            </div>
         </div>
      </div>
   );
};

export default ProfilAddUser;
